import { Editor, Transforms, Range, Text } from 'slate';
import addLink from '@atlas/tool/box/slate/addLink';
import isUrl from '@atlas/tool/box/type/isUrl';
import sortSelection from '@atlas/tool/box/slate/sortSelection';

export default function withLinks(editor: Editor) {
    const { insertData, normalizeNode, insertNodes } = editor;

    editor.insertNodes = (nodes, options) => {
        insertNodes(nodes, options);

        const marks = Editor.marks(editor);

        if (marks?.link) {
            Editor.removeMark(editor, 'link');
        }
    };

    editor.insertData = (data) => {
        if (!editor.selection) return insertData(data);

        const content = data.getData('text/plain');
        if (!isUrl(content)) {
            insertData(data);
            return;
        }

        const { anchor } = editor.selection;

        if (Range.isCollapsed(editor.selection)) {
            Transforms.insertText(editor, content);
            Transforms.setSelection(editor, { anchor });
        }

        addLink(editor, content);

        const [, linkEnd] = sortSelection(editor.selection);
        Transforms.setSelection(editor, { focus: linkEnd, anchor: linkEnd });
        Editor.removeMark(editor, 'link');
    };

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;

        if (Text.isText(node) && typeof node.link === 'string') {
            if (!node.text) {
                Transforms.setNodes(editor, { link: null }, { match: (node) => node === node });
            }

            // Fix the issue when slate adds whitespaces before and after copied link
            if (/^\s+$/.test(node.text)) {
                Transforms.removeNodes(editor, { at: path });
            }
        }

        normalizeNode(entry);
    };

    return editor;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withLinks', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
